import { createOwnUpStyle } from '../../style';
export var OwnUpBoxStyle = createOwnUpStyle({
  display: 'block',
  variants: {
    inline: {
      display: 'inline-block'
    },
    socialDiv: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      paddingTop: '10px',
      paddingBottom: '10px',
      width: '80%'
    },
    socialIconsDiv: {
      justifyContent: 'flex-start',
      display: 'flex',
      padding: '0 20px 5px 15px'
    },
    linkDiv: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      paddingTop: '10px',
      paddingBottom: '10px',
      width: '80%'
    },
    linkIconsDiv: {
      justifyContent: 'flex-start',
      display: 'flex',
      padding: '0px 15px 5px 15px'
    }
  }
});